import React from 'react';

const NotificationToast = ({ message, type = 'info' }) => {
  const colors = {
    success: '#22c55e',
    error: '#ef4444',
    warning: '#f59e0b',
    info: '#667eea',
  };

  return (
    <div
      className="notification-toast"
      style={{
        borderColor: colors[type],
        borderLeft: `4px solid ${colors[type]}`,
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <span style={{ fontSize: '1.2rem' }}>
          {type === 'success' && '✅'}
          {type === 'error' && '❌'}
          {type === 'warning' && '⚠️'}
          {type === 'info' && 'ℹ️'}
        </span>
        <span style={{ color: 'white' }}>{message}</span>
      </div>
    </div>
  );
};

export default NotificationToast;